import axios from 'axios';
export default {
    namespaced: true,
	state: {
		articles:[]
    },
    getters: {
        getArticles(state) {
            return state.articles
        },
        getApiUri(state, getters, rootState, rootGetters) {
            return rootGetters['api/getBlogApi'];
        }
    },
    mutations: {
        setArticles(state, articles) {
            state.articles = [];
            for (let i = 0; i < articles.length; i++)
            state.articles.push(articles[i]);
        }
    },
    actions: {
        requestArticles(store) {
            axios.get(store.getters['getApiUri'], { headers: {
                'Content-type': 'application/json'
              }}).then(response => (store.commit('setArticles', response.data)))
              .catch(error => console.log(error));
        }
    }
}

